import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // əsas stil
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import azercellbg from "../assets/image/azercellbg.webp"

const BusinessPage = () => {
  const biznesimData = [
    {
      id: 0,
      title: "4GB",
      price: "15₼",
      features: [
        { icon: "fa-solid fa-infinity me-2", value: "Limitsiz", label: "Korporativ zənglər" },
        { icon: "fa-solid fa-globe me-2", value: "4 GB", label: "İnternet" },
        { icon: "fa-solid fa-mobile-screen me-2", value: "500 dəq.", label: "Ölkədaxili zənglər" },
        { icon: "fa-solid fa-comment-sms me-2", value: "500", label: "SMS" }
      ]
    },
    {
      id: 1,
      title: "8GB",
      price: "21₼",
      features: [
        { icon: "fa-solid fa-infinity me-2", value: "Limitsiz", label: "Korporativ zənglər" },
        { icon: "fa-solid fa-globe me-2", value: "8 GB", label: "İnternet" },
        { icon: "fa-regular fa-moon me-2", value: "1 GB", label: "*Əlavə internet" },
        { icon: "fa-solid fa-mobile-screen me-2", value: "1500 dəq.", label: "Ölkədaxili zənglər" },
        { icon: "fa-solid fa-comment-sms me-2", value: "1000", label: "SMS" }
      ]
    },
    {
      id: 2,
      title: "12GB",
      price: "26₼",
      features: [
        { icon: "fa-solid fa-infinity me-2", value: "Limitsiz", label: "Korporativ zənglər" },
        { icon: "fa-solid fa-globe me-2", value: "12 GB", label: "İnternet" },
        { icon: "fa-regular fa-moon me-2", value: "2 GB", label: "*Əlavə internet" },
        { icon: "fa-solid fa-mobile-screen me-2", value: "2500 dəq.", label: "Ölkədaxili zənglər" },
        { icon: "fa-solid fa-comment-sms me-2", value: "2000", label: "SMS" },
        { icon: "fa-solid fa-phone-volume me-2", value: "10 dəq.", label: "Beynəlxalq zənglər" }
      ]
    },
    {
      id: 3,
      title: "20GB",
      price: "36₼",
      features: [
        { icon: "fa-solid fa-infinity me-2", value: "Limitsiz", label: "Korporativ zənglər" },
        { icon: "fa-solid fa-globe me-2", value: "20 GB", label: "İnternet" },
        { icon: "fa-regular fa-moon me-2", value: "3 GB", label: "*Əlavə internet" },
        { icon: "fa-solid fa-mobile-screen me-2", value: "4000 dəq.", label: "Ölkədaxili zənglər" },
        { icon: "fa-solid fa-comment-sms me-2", value: "2000", label: "SMS" },
        { icon: "fa-solid fa-phone-volume me-2", value: "20 dəq.", label: "Beynəlxalq zənglər" }
      ]
    },
    {
      id: 4,
      title: "60GB",
      price: "56₼",
      features: [
        { icon: "fa-solid fa-infinity me-2", value: "Limitsiz", label: "Korporativ zənglər" },
        { icon: "fa-solid fa-globe me-2", value: "60 GB", label: "İnternet" },
        { icon: "fa-solid fa-mobile-screen me-2", value: "7000 dəq.", label: "Ölkədaxili zənglər" },
        { icon: "fa-solid fa-comment-sms me-2", value: "3000", label: "SMS" },
        { icon: "fa-solid fa-phone-volume me-2", value: "30 dəq.", label: "Beynəlxalq zənglər" }
      ]
    },
    {
      id: 5,
      title: "100GB",
      price: "80₼",
      features: [
        { icon: "fa-solid fa-infinity me-2", value: "Limitsiz", label: "Korporativ zənglər" },
        { icon: "fa-solid fa-globe me-2", value: "100 GB", label: "İnternet" },
        { icon: "fa-solid fa-mobile-screen me-2", value: "**Limitsiz", label: "Ölkədaxili zənglər" },
        { icon: "fa-solid fa-comment-sms me-2", value: "1000", label: "SMS" },
        { icon: "fa-solid fa-phone-volume me-2", value: "100 dəq.", label: "Beynəlxalq zənglər" }
      ]
    }
  ];
  return (
    <>
      <section className="businesspage " style={{ background: "#fafafa" }}>
        <div className="container  ">
          <div className="row mx-2">
            {/* <div className="col-7">
              <h2>Ümumi məlumat</h2>
              <p>
                Azercell Biznesim tarif paketləri şirkətinizin ölkə üzrə harada
                olmasından asılı olmayaraq, effektiv fəaliyyət üstünlüyü bəxş
                edir. Bu çevik və müasir tarif paketləri ilə mobil rabitənizdən
                rahat və sərfəli şəkildə faydalana bilərsiniz. Biznesim
                sayəsində, siz həmişə əmin ola bilərsiniz ki, heç bir artıq xərc
                olmadan tələb olunan internet paketlərini əldə etmiş olursunuz.
                Beləliklə, işçiləriniz ölkəmizin istənilən yerində güclü 4G
                şəbəkəmizdən faydalanaraq, gözlənilməz xərclər barədə narahat
                olmayacaqlar. Bu, cari tarixdə çox vacibdir, çünki müasir
                işçilər iş şəraitləri və istifadə etdikləri cihazlara çox ciddi
                yanaşırlar.
              </p>
            </div>
            <div className="col-5">Right side</div> */}
            <h4 className="my-4" style={{ fontWeight: "bold" }}>Biznesim tarif planları</h4>
            <Swiper
              pagination={true}
              modules={[Pagination, Autoplay]}
              className="mySwiper  "
              breakpoints={{
                0: {
                  slidesPerView: 1, // 0 px-dən başlayaraq mobil üçün 1 slayd
                },
                768: {
                  slidesPerView: 4, // 768 px və yuxarı üçün 4 slayd
                },
              }}
              spaceBetween={10}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
            >
              {biznesimData.map((item) => {
                return (
                  <SwiperSlide key={item.id} style={{ height: "auto" }} className="mb-5">
                    <div className="col-12 mb-5 h-100">
                      <div className="biznesim h-100 d-flex flex-column">
                        <div className="flex-grow-1">
                          <div className="imgBox">
                            <img
                              src={azercellbg}
                              alt=""
                              className="img-fluid"
                            />
                            <div className="imgTitle">
                              <h5>Biznesim {item.title}</h5>
                              <p>{item.price}</p>
                            </div>
                          </div>

                          {item.features.map((feature, index) => (
                            <div className="details" key={index}>
                              <div className={`d-flex justify-content-start ms-3 ${index === 0 ? 'mt-3' : ''}`}>
                                <i className={feature.icon}></i>
                                <h6>
                                  {feature.value}
                                  <br />
                                  <p>{feature.label}</p>
                                </h6>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="d-flex justify-content-center align-items-center pb-3 mt-auto pt-4">
                          <div
                            className="d-flex justify-content-center align-items-center"
                            style={{
                              background: "#5C2483",
                              color: "#fff",
                              fontWeight: "bold",
                              width: "200px",
                              height: "40px",
                              borderRadius: "50px",
                              cursor: "pointer"
                            }}
                          >
                            Əlaqə
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
};

export default BusinessPage;
